import { Box } from '@mui/system';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { EditCellDropdown } from 'shared/components';
import { useDropdownOptions } from 'shared/queries';

export function MileageBucketDropdown(params: GridRenderCellParams<string>) {
  const { data } = useDropdownOptions('freight');

  if (data !== undefined) {
    return <EditCellDropdown data={data} params={params}></EditCellDropdown>;
  } else {
    return <Box>Loading...</Box>;
  }
}
